import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  numberStepper: {
    direction: 'ltr',
    lineHeight: 1,
    '& .center-part': {
      direction: theme.direction.value,
      overflow: 'hidden',
    },
    '& .button': {
      fontFamily: 'monospace',
      '& svg': {
        display: 'block',
        margin: '0 auto',
      },
    },
    '& .button[disabled]': {
      backgroundColor: 'transparent',
      color: `${theme.colors.gray.normal}`,
    },
  },
}));

export default useStyle;
